module.exports = __webpack_public_path__ + "static/img/zdhf07.660c871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf07.png
// module id = 124
// module chunks = 0